import { useCheckTable } from "hooks/useCheckTable";
import { checkDisableMultiple } from "pages/creditBills/utils/actionMaker";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import { bool, func, string } from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actions as creditBillActions } from "reducers/creditBills";
import MultipleActionSelector from "../MultipleActionSelector";
import CreditBillItem from "./ItemRow";
import CreditBillTitleColumns from "./TitleColumns";

const CreditBillTable = ({ isDesktop, fetchMoreBills, tabOption }) => {
    const { creditBillList, checkedBills, filters = {}, fetching, totalPages } = useSelector(
        (state) => state.creditBills,
    );
    const { pageNumber } = filters;
    const row = isDesktop ? 1 : 3;
    const hasMoreData = pageNumber < totalPages;

    const hookProperties = {
        list: creditBillList,
        initChecked: checkedBills,
        setChecked: creditBillActions.setChechedBills,
        key: "facturaId",
        configId: "creditBill.multiple.selection.max",
        i18nId: "creditBill.multiple.selection.max",
        scope: "creditBillsPage",
        validateCheckFn: checkDisableMultiple,
        fnArg: [tabOption],
    };

    const { selectedItems: selectedBills, hookFn } = useCheckTable(hookProperties);
    const { handleCheckAll, handleSelectRow, areAllChecked } = hookFn;
    const hasMoreThan1Row = selectedBills?.length > 1;

    return (
        <>
            {hasMoreThan1Row && (
                <MultipleActionSelector selectedRows={selectedBills} tabOption={tabOption} isDesktop={isDesktop} />
            )}
            <ProductList
                fetchingWithPreviousData
                fetching={fetching}
                items={creditBillList || []}
                noDataText="global.no.results"
                noFiltersDataText="global.no.results"
                renderItem={(item) => (
                    <GridTable.Container
                        rows={row}
                        key={`credit-bill-item-${item.facturaId.numeroComprobante}`}
                        renderAs={Link}
                        to={`/creditBills/detail/${Object.values(item.facturaId).join("-")}/${tabOption.toLowerCase()}`}
                        className={!isDesktop && "box box-shadow"}>
                        <CreditBillItem
                            billItem={item}
                            onSelectRow={handleSelectRow}
                            selectedBills={selectedBills}
                            isDesktop={isDesktop}
                            tabOption={tabOption}
                        />
                    </GridTable.Container>
                )}>
                {(listItem) => (
                    <>
                        <GridTable className="tablelist received">
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container>
                                        <CreditBillTitleColumns
                                            onCheckAll={handleCheckAll}
                                            areAllChecked={areAllChecked}
                                            tabOption={tabOption}
                                            isDesktop={isDesktop}
                                        />
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body className={isDesktop && "main-row-class"}>{listItem}</GridTable.Body>
                        </GridTable>
                        {hasMoreData && (
                            <GridTable.Container>
                                <GridTable.Data columnStart={7} columnWidth={2}>
                                    <Button
                                        bsStyle="link"
                                        onClick={() => fetchMoreBills(pageNumber + 1)}
                                        image="images/figma/icon/arrow.svg"
                                        label="global.showMore"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        )}
                    </>
                )}
            </ProductList>
        </>
    );
};

CreditBillTable.propTypes = {
    isDesktop: bool.isRequired,
    tabOption: string.isRequired,
    fetchMoreBills: func.isRequired,
};

export default CreditBillTable;
